import { createStore } from "vuex";
import { userStore } from "@/store/modules/userStore";
import { alertStore } from "@/store/modules/alertStore";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  modules: {
    userStore,
    alertStore,
  },
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== "production",
});
